import styled, { css } from 'styled-components'
import { ViewAllButton } from '../../../CompanyBlock/CompanyBlock.css'
import { Title } from '../../../Container/Container.css'

export const MostUsageCVWrapper = styled.div`
    margin-right: -16px;
    ${ViewAllButton} {
        background-color: #F2F7FF;
        border-radius: 6px;
        width: calc(100% - 16px);
        padding: 12px 0;
        text-align: center;
    }
`

export const MostUsageTitle = styled(Title)`
    width: 50%;
    @media (max-width: 767px) {
        width: 100%;
    }
`

export const ButtonWrapper = styled.div`
    display: none;
`

export const CVPreview = styled.a<{ isFullWidth?: boolean }>`
    display: inline-block;
    width: 100%;
    border: 1px solid #e2e2e2;
    border-radius: 6px;
    margin-right: 16px;
    aspect-ratio: 0.7073;
    object-fit: cover;
    position:  relative;
    img {
        border-radius: 6px;
    }
    @media screen and (max-width: 768px) {
        width: calc(100% - 16px);
    }
    &:hover {
        &::before {
            content: ' ';
            background-color: rgba(0, 0, 0, 0.7);
            border-radius: 6px;
            display: block;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: 1;
        }
        ${ButtonWrapper} {
            position: absolute;
            z-index: 2;
            left: 0;
            top: 0;
            width: 100%;
            height: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 6px;
        }
    }
    ${({ isFullWidth }) => {
        if (!isFullWidth) {
            return ''
        }
        return css`
            @media screen and (max-width: 768px) {
                width: 100%;
            }
        `
    }}
`
